import { render } from "./IconSparkles.vue?vue&type=template&id=60161dcc"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSparkles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60161dcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60161dcc', __exports__)) {
    api.reload('60161dcc', __exports__)
  }
  
  module.hot.accept("./IconSparkles.vue?vue&type=template&id=60161dcc", () => {
    api.rerender('60161dcc', render)
  })

}


export default __exports__